import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@devinforius/i-essentials';
import { Subscription } from 'rxjs';
import { Cols } from 'src/app/shared/models/cols';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-search-recipient',
  templateUrl: './search-recipient.component.html',
  styleUrls: ['./search-recipient.component.scss'],
})
export class SearchRecipientComponent implements OnInit {
  @Input() public contacts: Partial<Contact>[] = []; // uniquement pour le mode 'table'
  @Input() public mode: 'autocomplete' | 'table';
  @Input() contactTypes: { label: string; value: number }[]; // Uniquement pour le mode 'autocomplete'
  @Input() expediteurContactNeededToBeAdded; // Uniquement pour le mode 'autocomplete'
  @Input() contactOrigin: 'iAdmin' | 'iCourrier'; // Uniquement pour le mode 'autocomplete'
  @Output() public closeContactSearchModal: EventEmitter<Partial<Contact>> = new EventEmitter();
  public chosenRecipient: Partial<Contact> = null;
  public loaded = false;

  public contactsColumns: Cols[] = [];
  public contactsColumnsWithType: Cols[] = [];
  public subscriptionToAutocompleteSender: Subscription = null;
  public suggestions: Readonly<[]> = [];

  public displayAlertNotEnoughtLetters = true;

  constructor(
    private translater: TranslateService,
    private contactsService: ContactsService
  ) {}

  ngOnInit(): void {
    this.contactsColumns = [
      {
        field: 'label',
        header: this.translater.translate('name'),
        type: 'string',
      },
      {
        field: 'adresse',
        header: this.translater.translate('address'),
        type: 'string',
      },
    ];
    this.contactsColumnsWithType = [
      {
        field: 'label',
        header: this.translater.translate('name'),
        type: 'string',
      },
      {
        field: 'nameTypeContact',
        header: this.translater.translate('type'),
        type: 'string',
      },
      {
        field: 'adresse',
        header: this.translater.translate('address'),
        type: 'string',
      },
    ];
    this.loaded = true;
  }

  searchSenderAutoComplete(event): void {
    if (event.query.length < 3) {
      this.displayAlertNotEnoughtLetters = true;
      this.contacts = [];
      this.suggestions = [...this.suggestions];
    } else {
      if (this.subscriptionToAutocompleteSender !== null) {
        this.subscriptionToAutocompleteSender.unsubscribe();
        this.contactsService.stopRequestAutocompleteSender.next();
        this.contactsService.stopRequestAutocompleteSender.complete();
      }

      this.subscriptionToAutocompleteSender = this.contactsService
        .getLowInformationsContactsByAppSubject(this.contactOrigin, {
          search: event.query,
          includeAddressPrincipal: true,
        })
        .subscribe({
          next: (contacts) => {
            this.contacts = _.sortBy(this.formatContacts(contacts), 'label');
            this.contacts = [...this.contacts];
            this.suggestions = [...this.suggestions];
            this.displayAlertNotEnoughtLetters = false;
          },
        });
    }
  }

  private formatContacts(contacts): Contact[] {
    contacts.map((c) => {
      c.nameTypeContact = this.contactTypes.find((x) => {
        return x.value === c.typeContactID;
      })?.label;
      c.label = (c.prenom ? c.prenom : '') + ' ' + (c.nom ? c.nom : '');
      c.value = c.id;
      c.adresse = c.adressePrincipale
        ? (c.adressePrincipale?.impression_Adresse ? c.adressePrincipale.impression_Adresse + ' ' : '') +
          (c.adressePrincipale?.impression_CodePostal ? c.adressePrincipale.impression_CodePostal + ' ' : '') +
          (c.adressePrincipale?.impression_Localite ? c.adressePrincipale.impression_Localite + ' ' : '') +
          (c.adressePrincipale?.impression_Pays ? c.adressePrincipale.impression_Pays : '')
        : '';
      c.canVisualizeContact = !c.typeContactID || this.contactTypes.map((type) => type.value).indexOf(c.typeContactID) !== -1;
    });
    // Si on avait un expéditeur de base dans le courrier, on va vérifier s'il existe dans la liste récupérée de la recherche.
    // Comme ça s'il est inactif, on le garde dans la liste filtrée qui sera affichée à l'utilisateur (ICOUR-2943)
    let expediteurContactNeededToBeAddedFoundIdInList: Contact = null;
    if (this.expediteurContactNeededToBeAdded) {
      expediteurContactNeededToBeAddedFoundIdInList = contacts.find((contact) => contact.id === this.expediteurContactNeededToBeAdded.id);
    }
    contacts = contacts.filter((x) => x.nePlusUtiliser !== true && x.canVisualizeContact);
    if (expediteurContactNeededToBeAddedFoundIdInList?.nePlusUtiliser) {
      contacts.push(expediteurContactNeededToBeAddedFoundIdInList);
    }
    return contacts;
  }

  clearAutocomplete(): void {
    this.contacts = [];
    this.suggestions = [...this.suggestions];
    this.displayAlertNotEnoughtLetters = true;
  }

  onSubmit(): void {
    const chosenRecipient = this.chosenRecipient;
    this.chosenRecipient = null;
    this.closeContactSearchModal.emit(chosenRecipient);
  }
  onClose(): void {
    this.chosenRecipient = null;
    this.closeContactSearchModal.emit();
  }
}
